import { render } from "./formCurso.vue?vue&type=template&id=c0a6ea42&scoped=true"
import script from "./formCurso.vue?vue&type=script&lang=js"
export * from "./formCurso.vue?vue&type=script&lang=js"

import "./formCurso.vue?vue&type=style&index=0&id=c0a6ea42&lang=css"
import "./formCurso.vue?vue&type=style&index=1&id=c0a6ea42&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a6ea42"]])

export default __exports__